import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
    name:'lz30PurchaseLicenseFilterPipe'
})
export class LZ30PurchaseLicenseFilterPipe implements PipeTransform{
    transform(info: any, filterBillToName,filterShipToName,filterSerialNo) {
        if(info.length===0 || (filterBillToName=='' && filterShipToName=='' && filterSerialNo=='')){
            return info;
        }
        else{
            return info.filter((item)=>{
                    const serialNoList=item.DeviceSerialNos.split(',')
                    if(filterBillToName!='' && filterShipToName!='' && filterSerialNo!=''){
                        return (item.BillToName.toLowerCase()===filterBillToName.toLowerCase() && item.ShipToName.toLowerCase()===filterShipToName.toLowerCase() && serialNoList.some(serialNo=>{return serialNo===filterSerialNo}))
                    }
                    else if(filterBillToName=='' && filterShipToName!='' && filterSerialNo!=''){
                        return (item.ShipToName.toLowerCase()===filterShipToName.toLowerCase() && serialNoList.some(serialNo=>{return serialNo===filterSerialNo}))
                    }
                    else if(filterBillToName!='' && filterShipToName=='' && filterSerialNo!=''){
                        return (item.BillToName.toLowerCase()===filterBillToName.toLowerCase() && serialNoList.some(serialNo=>{return serialNo===filterSerialNo}))
                    }
                    else if(filterBillToName!='' && filterShipToName!='' && filterSerialNo==''){
                        return (item.BillToName.toLowerCase()===filterBillToName.toLowerCase() && item.ShipToName.toLowerCase()===filterShipToName.toLowerCase())
                    }
                    else if(filterBillToName=='' && filterShipToName=='' && filterSerialNo!=''){
                        return (serialNoList.some(serialNo=>{return serialNo===filterSerialNo}))
                    }
                    else if(filterBillToName!='' && filterShipToName=='' && filterSerialNo==''){
                        return (item.BillToName.toLowerCase()===filterBillToName.toLowerCase())
                    }
                    else if(filterBillToName=='' && filterShipToName!='' && filterSerialNo==''){
                        return (item.ShipToName.toLowerCase()===filterShipToName.toLowerCase())
                    }
                })
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/lz30/pipes/lz30PurchaseLicenseFilterPipe.ts